// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import router from './router'
import routes from './router/routes'
import Ajax from './mixins/Ajax'
import GlobalMixins from './mixins/GlobalMixins'
import Utilities from './mixins/Utilities'
import CommonFetches from './mixins/CommonFetches'

import Vue2TouchEvents from 'vue2-touch-events'

import moment from 'moment'
import accounting from 'accounting'

/*
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(regs => {
        regs.forEach(reg => reg.unregister());
    });
}
*/

Vue.config.productionTip = false

Vue.mixin(Ajax)
Vue.mixin(GlobalMixins)
Vue.mixin(CommonFetches)
Vue.mixin(Utilities)
Vue.use(Vue2TouchEvents)
let OneSignalAppId = false

if (window.location.hostname == "localhost")  {
	window.apiRoot = "https://api.dev.trade-traks.ca/"
	window.environment = "Development"
	OneSignalAppId = "83da97da-4173-4b1f-820b-068f92aaea0c"
}
else if (window.location.hostname == "fwe.tradetraks.app" || window.location.hostname == 'beta.tradetraks.app' || window.location.hostname == 'testing.tradetraks.app') { //beta branch
	window.apiRoot = "https://services.trade-traks.ca/"
	OneSignalAppId = "621c3912-a5d2-4db1-a4a1-137ba0f9d207"

	if (window.location.hostname == 'testing.tradetraks.app')
		window.environment = "Testing"
	else
		window.environment = "Beta"
}
else if (window.location.hostname == "tradetraks.app") {
	window.apiRoot = "https://services.trade-traks.ca/"
	OneSignalAppId = "d56d768c-9699-4dcd-87a1-347fde721b91"
	window.environment = "Production"
}

window.apiBase = window.apiRoot+"api/"
window.OneSignalAppId = OneSignalAppId

import store from "./store"

Vue.prototype.apiBase = window.apiBase
Vue.prototype.apiRoot = window.apiRoot

Vue.prototype.moment = moment
Vue.prototype.$bus = new Vue();
Vue.prototype.$store = store

Vue.prototype.accounting = accounting

window.App = new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
